import {
    ADD_OPEN_BET,
    CLEAR_OPEN_BETS_LIST,
    DISABLE_QUICK_FILL,
    DO_QUICK_FILL_BETS,
    REMOVE_CLOSED_EVENTS_OPEN_BETS,
    REMOVE_OPEN_BET,
    TOGGLE_COMMIT_BETS_ERROR,
    TOGGLE_COMMIT_BETS_SUCCESS,
    TOGGLE_COMMITTING_BETS,
    TOGGLE_QUICK_FILL,
    TOOGLE_EW_BET,
    UPDATE_OPEN_BET_MULTIPLIER,
    UPDATE_OPEN_BET_STAKE,
    AUTO_FOCUS_QUICK_FILL,
    UPDATE_UI_STATE,
    UPDATE_UI_STATE_TIMER,
    UNCHECK_QUICK_FILL
} from '../constants/actionTypes';
import {OPEN_BETS} from '../../../constants/localStorage';
import {isLocalStorageAvailable} from "../../../helpers/systemHelpers";
import {ADD_LOCAL_STORED_BETS} from "../../sports-book/constants/actionTypes";
import {getItem, setItem} from "../../../helpers/localStorageHelpers";
import {generateId} from "../helpers/betHelpers";
import {WARNING_NOTIFICATION} from "../../../constants/identifiers";

export function addOpenBet(bet, openBetsList) {
    //If bet type is acc dont check for 15 bets
    if (openBetsList.filter(eventBet => eventBet.bets.length === 1).length >= 15) {
        window.GAME.notifyPlayer(WARNING_NOTIFICATION, WARNING_NOTIFICATION, 'OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED');
        return {type: 'IGNORE'};
    }

    // set the bet unique id
    bet.uniqueId = generateId();

    return {type: ADD_OPEN_BET, bet};
}

export function checkForQuickSelect(betType, bets, openBetsList, isTextBasedEventsEnabled = false) {

    let singleBetsToRemove = [];
    if(isTextBasedEventsEnabled){
        singleBetsToRemove = openBetsList.filter(bet =>
            bet.bets.length == 1 && bet.bets[0].event.leagueDay === bets[0].event.leagueDay && bets.some(betRandom => betRandom.event.channel == bet.bets[0].event.channel));
    }else{
        singleBetsToRemove = openBetsList.filter(bet =>
            bet.bets.length == 1 && bet.bets[0].betType.code === betType.code && bets.some(betRandom => betRandom.event.eventId == bet.bets[0].event.eventId && betRandom.event.channel == bet.bets[0].event.channel));
    }
    if ((openBetsList.filter(eventBet => eventBet.bets.length === 1).length - singleBetsToRemove.length + bets.length) > 15) {
        window.GAME.notifyPlayer(WARNING_NOTIFICATION, WARNING_NOTIFICATION, 'OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED');
        return false;
    }
    return true;
}

export function isQuickBetSelected(openBetsList, type, betType) {
    return openBetsList.some(bet => bet.bets.length === 1 && bet.bets[0].selectionType === type && bet.bets[0].betType.code === betType);
}

export function toggleEwBet(betSelection) {
    return {type: TOOGLE_EW_BET, betSelection};
}

export function removeOpenBet(bet,isLastBet) {
    return {type: REMOVE_OPEN_BET, bet,isLastBet};
}

export function updateOpenBetStake(bet, stake) {
    return {type: UPDATE_OPEN_BET_STAKE, bet, stake};
}

export function updateOpenBetMultiplier(bet, multiplier) {
    return {type: UPDATE_OPEN_BET_MULTIPLIER, bet, multiplier};
}

export function clearOpenBetsList(keepBetsWithoutStake = false) {
    return {type: CLEAR_OPEN_BETS_LIST, keepBetsWithoutStake};
}

export function toggleCommitBetsSuccess() {
    return {type: TOGGLE_COMMIT_BETS_SUCCESS};
}

export function toggleCommitBetsError() {
    return {type: TOGGLE_COMMIT_BETS_ERROR};
}

export function toggleCommittingBets() {
    return {type: TOGGLE_COMMITTING_BETS};
}

export function addSportsBookLocalStoredBets(playerUID, noMoreBetsEventList) {
    if (!isLocalStorageAvailable) {
        // there is nothing to store if localStorage is not available
        console.warn('Browser local storage disabled, open bets cannot be cached.');
        return;
    }

    let unauthenticatedLocalOpenBets = getItem(undefined, OPEN_BETS);
    if (unauthenticatedLocalOpenBets === null) {
        unauthenticatedLocalOpenBets = [];
    }

    let localOpenBets = getItem(playerUID, OPEN_BETS);
    if (localOpenBets === null) {
        localOpenBets = [];
    }

    localOpenBets = localOpenBets.concat(unauthenticatedLocalOpenBets);
    let openBetsList = [];

    if (localOpenBets !== undefined && localOpenBets.length !== 0) {
        let currDate = new Date();
        openBetsList = localOpenBets.map(
            (obl) => {
                if (!(obl.bets[0].event.eventTimeDate > currDate.getTime() && !noMoreBetsEventList.find((nmbe) => nmbe.eventId === obl.bets[0].event.eventId && nmbe.gameChannel === obl.bets[0].event.channel))) {
                    obl.bets.map((bet) => bet.hasExpired = true);
                }
                return obl;
            }
        );
        openBetsList = openBetsList.filter(ob => ob.bets[0].hasExpired !== true);
    }

    if (isLocalStorageAvailable) {
        localStorage.removeItem(OPEN_BETS);
        if (openBetsList.length !== 0) {
            setItem(playerUID, OPEN_BETS, openBetsList);
        } else {
            setItem(playerUID, OPEN_BETS, []);
        }
    }

    if (localOpenBets === undefined || localOpenBets.length === 0) {
        return {type: 'IGNORE'};
    } else {
        return {type: ADD_LOCAL_STORED_BETS, openBetsList};
    }
}

export function removeClosedEventsOpenBets() {
    return {type: REMOVE_CLOSED_EVENTS_OPEN_BETS};
}

export function doQuickFillBets(quickFillStake, minorCurrencyUnits, systemLanguage, systemCurrency) {
    return {type: DO_QUICK_FILL_BETS, quickFillStake, minorCurrencyUnits, systemLanguage, systemCurrency};
}

export function toggleQuickFill(quickFillBoxCheckStatus) {
    return {type: TOGGLE_QUICK_FILL, quickFillBoxCheckStatus};
}

export function disableQuickFill(quickFillDisableStatus) {
    return {type: DISABLE_QUICK_FILL, quickFillDisableStatus};
}

export function uncheckQuickFill() {
    return {type: UNCHECK_QUICK_FILL};
}

export function autofocusQuickFill(quickFillStatus) {
    return {type: AUTO_FOCUS_QUICK_FILL, quickFillStatus};
}

export function updateUIState(status) {
    return {type: UPDATE_UI_STATE, status};
}

export function updateUIStateTimer(busyStateTimer) {
    return {type: UPDATE_UI_STATE_TIMER, busyStateTimer};
}



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/actions/openBetsActions.js